import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import DualSquareSelector from "../../Square/SquareDiv";
import SelectMulti from "../../MultiSelect/MultiSelect";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import CheckboxGroup from "../../CheckBoxGroup/CheckboxGroup";
import Select from 'react-select'
import { useSelector } from 'react-redux';

function CreateUserr() {

  const selectorRef = useRef();

  const [Permissions, setPermissions] = useState([])
  const [selectedPermissionGroupItems, setSelectedPermissionGroupItems] = useState([]);
  const [selectCommissionGroups, setSelectCommissionGroups] = useState([])
  const [selectAffiliateGroups, setSelectAffiliateGroups] = useState([])
  const [resetMultiSelect, setresetMultiSelect] = useState(false)
  const [loadingpermission, setLoadingpermission] = useState(false)
  const [selectedPermission, setSelectedPermission] = useState([])
  const [resetTrigger, setResetTrigger] = useState(0);
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([]);
  const [loadingCreate, setloadingCreate] = useState(false)
  const [user, setUser] = useState({
    username: "",
    password: "",
    repassword: "",
    email: "",
    commissiongroups: [],
    affiliategroups: [],
    permissions: []
  })
  const [validation, setValidation] = useState({
    username: null,
    password: null,
    repassword: null,
    email: null,
    match: null
  })
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliatePermission, setAffliatePermission] = useState(false)
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const handleResetClick = () => {
    if (selectorRef.current) {
      selectorRef.current.resetSelection();
    }
  };

  const handleSelectionPermissionGroupChange = (selectedRows) => {
    setSelectedPermissionGroupItems(selectedRows);
  };
  const handleSelectionCommissionChange = (selectedItems) => {
    setSelectCommissionGroups(selectedItems)
  };
  const handleSelectionAffiliateChange = (selectedItems) => {
    setSelectAffiliateGroups(selectedItems)
  };

  const createUser = async () => {
    var userIterator = Object.assign({}, user)
    var initValidation = {
      username: null,
      password: null,
      repassword: null,
      email: null,
      match: null
    }
    var errored = false;
    if (userIterator.username === "") {
      initValidation.username = "username field is required"
      errored = true
    }
    if (userIterator.email === "") {
      initValidation.email = "email field is required"
      errored = true
    }
    if (userIterator.password === "") {
      initValidation.password = "password field is required"
      errored = true
    }
    if (userIterator.repassword === "") {
      initValidation.repassword = "repeat password field is required"
      errored = true
    }
    if (userIterator.repassword !== userIterator.password) {
      initValidation.match = " password doen't match to repeat password"
      errored = true
    }
    setValidation(initValidation)
    if (errored) return;
    if (selectAffiliateGroups.length > 0)
      userIterator.affiliategroups = selectAffiliateGroups
    if (selectCommissionGroups.length > 0)
      userIterator.commissiongroups = selectCommissionGroups
    if (selectedPermission.length > 0)
      userIterator.permissions = Object.values(selectedPermission[0]).flat();
    setloadingCreate(true)
    const response = await axios.post(window.__CFG.API + "manager/CreateUser", userIterator, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error == null) {
      toast.success("Updated Sucessufully", {
        duration: 4000
      });
      handleResetClick()
      setresetMultiSelect(true)
      setUser({
        username: "",
        password: "",
        repassword: "",
        email: "",
        commissiongroups: [],
        affiliategroups: [],
        permissions: []
      })
      setSelectedPermission([])
      handleReset() //reset state chekcbox grp
    }
    else {
      toast.error(response.data.Error, {
        duration: 4000
      });
    }
    setloadingCreate(false)
  }
  const getAllPermissions = async () => {
    setLoadingpermission(true)
    const response = await axios.get(window.__CFG.API + "manager/ListAllPermissions", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setLoadingpermission(false)
    if (response.data.Error == null) {
      setPermissions(response.data.Result)
    }
  }
  const handleGroupChange = (updatedState) => {
    var initarr = []
    initarr.push(updatedState)
    setSelectedPermission(initarr)
  };
  const handleReset = () => {
    // Change resetTrigger value to trigger the reset in CheckboxGroup
    setResetTrigger(prev => prev + 1);
  };
  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); }, [])
  useEffect(() => { getAllPermissions() }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)
  useEffect(() => { setAffliatePermission(checkPermission(affliate, "set_add_user")) }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  return (
    <Container>
      <Row>
        <Col>
          <h4 className="text-start fw-bold mt-4">Create user</h4>

          <Row className="justify-content-between mt-4 me-auto w-100">
            <Col lg={5} md={4} sm={4}>
              <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                <label>username </label>
              </div>
              <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="text" value={user.username} onChange={(e) => { setUser({ ...user, username: e.target.value }) }} />
              {
                validation.username !== null ? (
                  <div class="invalid-feedback loginForm">
                    {validation.username}
                  </div>
                ) : (
                  <></>
                )
              }
            </Col>
            <Col lg={5} md={4} sm={5}>
              <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                <label>password </label>
              </div>
              <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="password" value={user.password} onChange={(e) => { setUser({ ...user, password: e.target.value }) }} />
              {
                validation.password !== null ? (
                  <div class="invalid-feedback loginForm">
                    {validation.password}
                  </div>
                ) : (
                  <></>
                )
              }
            </Col>
          </Row>

          <Row className="justify-content-between mt-2 me-auto w-100">
            <Col lg={5} md={4} sm={4}>
              <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                <label>email </label>
              </div>
              <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="email" value={user.email} onChange={(e) => { setUser({ ...user, email: e.target.value }) }} />
              {
                validation.email !== null ? (
                  <div class="invalid-feedback loginForm">
                    {validation.email}
                  </div>
                ) : (
                  <></>
                )
              }
            </Col>
            <Col lg={5} md={4} sm={5}>
              <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                <label> repeat password </label>
              </div>
              <Form.Control disabled={!affliatePermission} style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)", padding: 4 }} type="password" value={user.repassword} onChange={(e) => { setUser({ ...user, repassword: e.target.value }) }} />
              {
                validation.repassword !== null ? (
                  <div class="invalid-feedback loginForm">
                    {validation.repassword}
                  </div>
                ) : (
                  <></>
                )
              }
              {
                validation.match !== null ? (
                  <div class="invalid-feedback loginForm">
                    {validation.match}
                  </div>
                ) : (
                  <></>
                )
              }
            </Col>
          </Row>

          <Row className="justify-content-between mt-2 me-auto w-100">
            <Col lg={5} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp" style={{ display: "grid" }}>
                <div className="form-cre-grp-fl-wp-lb" style={{ paddingBottom: 5 }}>
                  <label>commission group</label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <SelectMulti reset={resetMultiSelect} options={affliatePermission ? ltComGrp : []} onSelectionChange={handleSelectionCommissionChange} />
                </div>
              </div>
            </Col>
            <Col lg={5} md={4} sm={4}>
              <div style={{ marginBottom: 5 }} className='form-aff-list-in-lab'>
                <label> Currency</label>
              </div>
              <Select isDisabled={!affliatePermission} options={optionsCurrency} value={selectedCurrencyValue} />

            </Col>

          </Row>

          <Row className="justify-content-between mt-2 me-auto w-100">

            <Col lg={5} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp" style={{ display: "grid" }}>
                <div className="form-cre-grp-fl-wp-lb" style={{ paddingBottom: 5 }}>
                  <label>affiliate group</label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <SelectMulti reset={resetMultiSelect} options={affliatePermission ? ltAffGrp : []} onSelectionChange={handleSelectionAffiliateChange} />
                </div>
              </div>
            </Col>
            <Col lg={5} md={4} sm={5} className=" pt-2 mb-5 md-se-btn" style={{ marginTop: "15px" }}>
              <Button disabled={!affliatePermission || loadingCreate} onClick={createUser} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                {loadingCreate ? (<> <Spinner size="sm"></Spinner></>) : (<>
                  Save

                </>)}
              </Button>
            </Col>
          </Row>
          <div
            style={{
              borderBottom: "1px dashed black",
              marginTop: "20px",
              width: "100%",
            }}
          ></div>

          <div>
            <Row className="justify-content-between mt-2 me-auto w-100">
              <Col lg={5} md={4} sm={5} className=" " style={{ paddingBottom: 10 }}>
                <h4 className="text-start fw-bold mt-4">Affiliate permission</h4>
              </Col>
            </Row>
            <CheckboxGroup resetTrigger={resetTrigger} disabled={!affliatePermission} items={Permissions} onChange={handleGroupChange} loadingf={loadingpermission} autoSelect={selectedPermission} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default CreateUserr;
